import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import ArrowLeft from '../../../Icons/ArrowLeft';
import Flex from '../../../Flex';
import { IconSize } from '../../../Icons/IconWrap';
import s from './MobileLayout.scss';
export var MobileTitle = function (_a) {
    var selectedGroup = _a.selectedGroup, onResetSelectedGroup = _a.onResetSelectedGroup;
    var t = useTranslation().t;
    if (selectedGroup) {
        return (React.createElement(Flex, { alignItems: "center", className: s['real-header'] },
            React.createElement("button", { className: s['back-button'], onClick: onResetSelectedGroup },
                React.createElement(ArrowLeft, { size: IconSize.SMALL })),
            React.createElement("span", { className: s['title'] },
                React.createElement(Trans, { i18nKey: "addToGroup.addToAGroup" },
                    "Add to ",
                    React.createElement("span", { className: s['username'] }, { username: selectedGroup.username }),
                    " group"))));
    }
    return React.createElement("div", { className: s['real-header'] }, t('addToGroup'));
};
MobileTitle.displayName = 'MobileTitle';
export default MobileTitle;
//# sourceMappingURL=MobileTitle.js.map